
import {
  computed, defineComponent, reactive,
} from 'vue';
import Card from '@/core/components/Tela/Card.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import SelecionarTipoCusto from '@/components/Cadastros/Precificacao/SelecionarTipoCusto.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { ITabelaPrecoItemProduto } from '@/models/Entidades/Cadastros/Precificacao/ITabelaPreco';
import { IDTOTabelaPreco } from '@/models/DTO/Cadastros/Precificacao/IDTOTabelaPreco';
import { ITipoPreco } from '@/models/Entidades/Cadastros/Precificacao/ITipoPreco';
import { IProdutoCusto } from '@/models/Entidades/Cadastros/Produtos/IProduto';
import UtilitarioMatematico from '@/core/utilitarios/UtilitarioMatematico';

export default defineComponent({
  name: 'ProdutoPrecos',
  props: {
    empresa: {
      type: Number,
      required: true,
    },
    tiposPrecos: {
      type: Array as () => ITipoPreco[],
      required: true,
    },
    tabelasPrecos: {
      type: Array as () => IDTOTabelaPreco[],
      required: true,
    },
    precos: {
      type: Array as () => ITabelaPrecoItemProduto[],
      required: true,
    },
    custos: {
      type: Array as () => IProdutoCusto[],
      required: true,
    },
    carregando: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    CampoNumerico,
    Card,
    MensagemSemDados,
    SelecionarTipoCusto,
  },
  emits: ['update:precos'],
  setup(props, { emit }) {
    const state = reactive({});

    const computedPrecos = computed({
      get: () => props.precos,
      set: (valor: ITabelaPrecoItemProduto[]) => {
        emit('update:precos', valor);
      },
    });

    function obterIndex(codigoTabela: number, codigoTipoPreco: number): number {
      if (UtilitarioGeral.validaLista(computedPrecos.value)) {
        const index = computedPrecos.value.findIndex((c) => c.codigoTabelaPreco === codigoTabela && c.codigoTipoPreco === codigoTipoPreco);
        if (index >= 0) { return index; }
      }

      return 0;
    }

    function verificarTipoPrecoEstrutura(tipoPreco: number, tabelaPreco: IDTOTabelaPreco) {
      const index = tabelaPreco.estruturas.findIndex((e) => e.codigoTipoPreco === tipoPreco);
      return index > -1;
    }

    function atualizarPrecoMarkup(indexTipoPreco: number, markup: boolean) {
      const indexCusto = props.custos.findIndex((c) => c.codigoTipoCusto === computedPrecos.value[indexTipoPreco].codigoTipoCusto);
      const valorCusto = props.custos[indexCusto].valor;
      if (markup) {
        computedPrecos.value[indexTipoPreco].valor = valorCusto + UtilitarioMatematico.calcularValorPercentual(valorCusto, computedPrecos.value[indexTipoPreco].markup);
      } else if (valorCusto > 0 && computedPrecos.value[indexTipoPreco].valor) {
        const valorDiferenca = computedPrecos.value[indexTipoPreco].valor - valorCusto;
        const valroCalculado = UtilitarioMatematico.calcularPorcentagem(valorCusto, valorDiferenca);
        computedPrecos.value[indexTipoPreco].markup = valroCalculado;
      }
    }

    return {
      props,
      state,
      computedPrecos,
      obterIndex,
      verificarTipoPrecoEstrutura,
      atualizarPrecoMarkup,
    };
  },
});
